// @flow

import React from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import jquery from 'jquery';
import FroalaEditor from 'froala-editor';
import {
  LoadableImageEditor,
  convertToBlob,
} from 'app/components/general/LoadablaImageEditor';
import {sendSentryError} from 'app/utils/sentry';

const containerClass = 'basic-image-editor_container';

FroalaEditor.PLUGINS.imageEditor = function (editor: any) {
  let modalContainer: HTMLDivElement;
  let editorInstance: any;
  let imageRef: HTMLImageElement;
  let imageURL: string;

  //eslint-disable-next-line no-underscore-dangle
  function _init() {
    modalContainer = getContainer();
  }

  function getContainer() {
    return (
      jquery(`body > .${containerClass}`).get(0) ||
      jquery('<div />').addClass(containerClass).appendTo('body').get(0)
    );
  }

  function onExport(imageURL) {
    const imageBlob = convertToBlob(imageURL);
    const $image = jquery(imageRef);
    editorInstance.image.edit($image);
    editorInstance.image.upload([imageBlob]);
    //unmount the editor instance
    renderEditor(false);
  }

  function invalidateCache(url) {
    if (url.substr(0, 5) === 'blob:') {
      return url;
    }

    const link = document.createElement('a');
    link.href = url;
    const search = link.search;
    const now = new Date().getTime();
    return `${url}${search === '' ? '?' : '&'}${now}`;
  }

  function hideEditor() {
    renderEditor(false);
  }

  function unmount() {
    unmountComponentAtNode(modalContainer);
  }

  function launch(instance) {
    editorInstance = instance;
    imageRef = editorInstance.image.get()[0];

    const {mediaURL, mediaURLRead} = editor.opts.imageEditorExtra;
    imageURL = invalidateCache(imageRef.src.replace(mediaURLRead, mediaURL));

    renderEditor(true);
  }

  function handleError(error, canClosePromise) {
    sendSentryError(error, {
      extra: {
        originalImageURL: imageRef.src,
        imageURL,
      },
    });
    canClosePromise.then(() => renderEditor(false));
  }

  function renderEditor(show) {
    // our CDN doesn't support CORS so let's get the image
    // directly from S3 bucket

    render(
      <LoadableImageEditor
        image={imageURL}
        show={show}
        onError={handleError}
        onClose={hideEditor}
        onExited={unmount}
        onSave={onExport}
        saveOptions={
            {quality: 0.8}  // an OK quality level to prevent large images being exported.
        }
      />,
      modalContainer
    );
  }

  return {
    _init: _init,
    launch: launch,
  };
};

FroalaEditor.DefineIcon('imageEditor', {
  NAME: 'sliders-h',
  FA5NAME: 'sliders-h',
});

FroalaEditor.RegisterCommand('imageEditor', {
  title: 'Advanced Edit',
  undo: false,
  focus: false,
  callback: function () {
    this.imageEditor.launch(this);
  },
  plugin: 'imageEditor',
});

// Look for image plugin.
if (!FroalaEditor.PLUGINS.image) {
  throw new Error('imageEditor plugin requires image plugin.');
}

FroalaEditor.DEFAULTS.imageEditButtons.push('imageEditor');
